import React from 'react';
// Constants
import { CompanyName, FETLIFE_URL, TWITTER_URL } from '../../utils/Constants';
// Data
import {
  adultBabyServicesPageAdditionalMeta,
  adultBabyServicesPageStructuredData,
} from '../../utils/data/MetaData';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import BabyServicesPageMainContainer from '../../components/services/BabyServicesPageMainContainer';
import HeaderBanner from '../../components/general/HeaderBanner';
import AltHeader from '../../components/general/AltHeader';
import FooterComponent from '../../components/footer/FooterComponent';
// Images
import BgImage from '../../assets/images/backgrounds/playful-background-images.webp';

function BabyServicesPage() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Adult Baby Services'
        desc={`Discover nurturing and immersive Adult Baby services with ${CompanyName}. Mistress Maria offers compassionate ABDL sessions—both in person and online—designed to guide, discipline, and care for your adult baby needs.`}
        keywords={`Mistress Maria Adult Baby, ABDL services, Adult Baby sessions, nurturing Dominatrix, ABDL Norfolk, discipline and care, age regression, adult baby play, online ABDL sessions, in-person ABDL`}
        additionalMeta={adultBabyServicesPageAdditionalMeta}
        structuredData={adultBabyServicesPageStructuredData}
      />

      {/* Page */}
      <div
        className='grid min-h-screen overflow-hidden bg-colour1 dark:bg-colour2 text-colour2 dark:text-colour1 font-poppins'
        style={{
          backgroundImage: `url(${BgImage})`,
          backgroundRepeat: 'repeat-y',
          backgroundSize: '100% auto',
          backgroundPosition: 'top center',
        }}
      >
        <div className='grid h-fit'>
          {/* Alt */}
          <AltHeader />

          {/* Navigation */}
          <Navbar />

          {/* Header */}
          <header className='grid pt-12 z-10'>
            <HeaderBanner message={`Adult baby services`} />

            <section className='grid w-full'>
              <div className='grid w-full px-6 bg-colour1/80 lg:container lg:mx-auto gap-8 py-8 text-lg tracking-wider'>
                <p className=''>
                  I am Nanny M a leading ABDL role player in the UK, my
                  commitment and passion to the scene began nearly 20 years ago
                  at the original Happy2nappy nursery in Kent . Offering a safe
                  and nurturing space to explore your Adult Baby side. Based in
                  Norfolk, my sessions blend gentle care with firm guidance to
                  help you embrace age regression and ABDL play.
                </p>
                <p>
                  I can be as nurturing or restrict as you would like sent.
                  Soothing Sensual cuddles with bottle feeding and bedtime
                  stories or strict no nonsense approach involving various safe
                  restraints, humiliation and a lot more, it really is your
                  choice!
                </p>
                <p>
                  Whether you seek comforting nurturing, structured discipline,
                  roleplay, or regression, I tailor each session to your unique
                  needs and boundaries. Sessions are available both in person
                  and online via WhatsApp, email, or text. Come surrender to
                  care, control, and acceptance in a judgment-free environment.
                </p>
                <p>
                  My highly-equipped nursery will soon be operational at its new location. I recommend checking for announcements here and on other key platforms such as <a href={FETLIFE_URL} className='font-medium italic text-colour6'>fetlife</a> and <a href={TWITTER_URL} className='font-medium italic text-colour6'>X</a>, which I frequent.
                </p>
              </div>
            </section>
          </header>
        </div>
        {/* Main page content */}
        <BabyServicesPageMainContainer />
        {/* Footer */}
        <FooterComponent />
      </div>
    </>
  );
}

export default BabyServicesPage;
